import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Slider from "react-slick"

import Components from "../../components"

const Carousel = ({ blok }) => (
  <SbEditable content={blok}>
    <Slider
      className="carousel"
      slidesToShow={parseInt(blok.slides_to_show)}
      slidesToScroll={1}
      dots={true}
      adaptiveHeight={true}
      responsive={[
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
          },
        },
      ]}
    >
      {blok.carousel_content &&
        blok.carousel_content.map((c) =>
          React.createElement(Components(c.component), {
            key: c._uid,
            blok: c,
          })
        )}
    </Slider>
  </SbEditable>
)

Carousel.propTypes = {
  blok: PropTypes.shape({
    slides_to_show: PropTypes.string,
    carousel_content: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default Carousel
